import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

/**
 * Global gate for Resource Portal routes.
 *
 * Rules:
 *   1. Not logged in                              → redirect to /login (preserving `from`)
 *   2. Logged in but has_resources_access=false   → redirect to /pricing
 *   3. Logged in and has_resources_access=true    → render children
 *
 * While the initial /api/auth/me check is in flight (`user === null`), we render a
 * minimal blank placeholder so the layout doesn't flash a logged-out UI first.
 */
const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    // still verifying session
    return (
      <div className="min-h-screen bg-white" aria-hidden data-testid="auth-checking" />
    );
  }

  if (user === false) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (!user.has_resources_access) {
    return <Navigate to="/pricing" state={{ from: location.pathname }} replace />;
  }

  return children;
};

export default ProtectedRoute;
